import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {EmailInboundComponent} from './email-inbound/email-inbound.component';

import {AuthGuard} from '../../core/_guards/auth.guard';
import {AppDefaultLayoutComponent} from 'src/app/layout/app-default-layout/app-default-layout.component';
const routes: Routes = [
    {
        path: '',
        component: AppDefaultLayoutComponent,
        children: [{path: 'email-contact', component: EmailInboundComponent, canActivate: [AuthGuard]}],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class EmailRoutingModule {}
